
import SignIn from "../Auth/Signin";

// Dashboard
import Dashboard from "../Screens/Dashboard";

// Inventory
import InventoryMain from "../Screens/Inventory/InventoryMain";
import InventoryCreate from "../Screens/Inventory/InventoryCreate";
import BulkAssign from "../Screens/Inventory/BulkAssign";

// Lot
import LotMain from "../Screens/Lot/LotMain";
import LotCreate from "../Screens/Lot/LotCreate";
import LotEdit from "../Screens/Lot/LotEdit";
import LotView from "../Screens/Lot/LotView";

// Reservation
import ReservationMain from "../Screens/Reservation/ReservationMain";
import ReservationCreate from "../Screens/Reservation/ReservationCreate";
import ReservationEdit from "../Screens/Reservation/ReservationEdit";
import ReservationView from "../Screens/Reservation/ReservationView";

// User
import UserMain from "../Screens/User/UserMain";
import UserCreate from "../Screens/User/UserCreate";
import UserEdit from "../Screens/User/UserEdit";

// Settings
import Settings from "../Screens/Settings/Settings";

// Activity Log
import ActivityLog from "../Screens/ActivityLog/ActivityLog";

// Errors
import Error400 from "../Components/Pages/ErrorPages/ErrorPage400";
import Error401 from "../Components/Pages/ErrorPages/ErrorPage401";
import Error403 from "../Components/Pages/ErrorPages/ErrorPage403";
import Error404 from "../Components/Pages/ErrorPages/ErrorPage404";
import Error500 from "../Components/Pages/ErrorPages/ErrorPage500";
import Error503 from "../Components/Pages/ErrorPages/ErrorPage503";
import Profile from "../Screens/User/Profile";
import TransactionMain from "../Screens/Transaction/TransactionMain";
import Report from "../Screens/Report/Report";
import InventoryView from "../Screens/Inventory/InventoryView";
import InventoryEdit from "../Screens/Inventory/InventoryEdit";
import PackageMain from "../Screens/Package/PackageMain";
import PackageCreate from "../Screens/Package/PackageCreate";
import PackageEdit from "../Screens/Package/PackageEdit";
import PackageView from "../Screens/Package/PackageView";
import PromotionMain from "../Screens/Promotion/PromotionMain";
import PromotionCreate from "../Screens/Promotion/PromotionCreate";
import PromotionEdit from "../Screens/Promotion/PromotionEdit";
import PromotionView from "../Screens/Promotion/PromotionView";
import Page from "../Screens/Page/Page";

export const routes = [
  // auth
  { path: `${process.env.PUBLIC_URL}/login`, Component: <SignIn /> },

  // dashboard
  { path: `${process.env.PUBLIC_URL}/dashboard`, Component: <Dashboard /> },

  // inventory
  { path: `${process.env.PUBLIC_URL}/inventory`, Component: <InventoryMain />, roles: ["superadmin", "operation", "finance", "security"] },
  { path: `${process.env.PUBLIC_URL}/inventory/create`, Component: <InventoryCreate />, roles: ["superadmin", "finance"] },
  { path: `${process.env.PUBLIC_URL}/inventory/view/:id`, Component: <InventoryView />, roles: ["superadmin", "operation", "finance"] },
  { path: `${process.env.PUBLIC_URL}/inventory/edit/:id`, Component: <InventoryEdit />, roles: ["superadmin", "finance"] },
  { path: `${process.env.PUBLIC_URL}/inventory/bulk-assign/:id`, Component: <BulkAssign />, roles: ["superadmin", "finance"] },

  // lots
  { path: `${process.env.PUBLIC_URL}/lots`, Component: <LotMain />, roles: ["superadmin", "operation", "finance", "security"] },
  { path: `${process.env.PUBLIC_URL}/lots/create`, Component: <LotCreate />, roles: ["superadmin", "finance"] },
  { path: `${process.env.PUBLIC_URL}/lots/edit/:id`, Component: <LotEdit />, roles: ["superadmin", "finance"] },
  { path: `${process.env.PUBLIC_URL}/lots/view/:id`, Component: <LotView />, roles: ["superadmin", "operation", "finance", "security"] },
  
  // packages
  { path: `${process.env.PUBLIC_URL}/packages`, Component: <PackageMain />, roles: ["superadmin", "operation", "finance", "security"] },
  { path: `${process.env.PUBLIC_URL}/packages/create`, Component: <PackageCreate />, roles: ["superadmin", "finance"] },
  { path: `${process.env.PUBLIC_URL}/packages/edit/:id`, Component: <PackageEdit />, roles: ["superadmin", "finance"] },
  { path: `${process.env.PUBLIC_URL}/packages/view/:id`, Component: <PackageView />, roles: ["superadmin", "operation", "finance"] },
  
  // promotions
  { path: `${process.env.PUBLIC_URL}/promotions`, Component: <PromotionMain />, roles: ["superadmin", "operation", "finance", "security"] },
  { path: `${process.env.PUBLIC_URL}/promotions/create`, Component: <PromotionCreate />, roles: ["superadmin", "finance"] },
  { path: `${process.env.PUBLIC_URL}/promotions/edit/:id`, Component: <PromotionEdit />, roles: ["superadmin", "finance"] },
  { path: `${process.env.PUBLIC_URL}/promotions/view/:id`, Component: <PromotionView />, roles: ["superadmin", "operation", "finance", "security"] },

  // reservations
  { path: `${process.env.PUBLIC_URL}/reservations`, Component: <ReservationMain />, roles: ["superadmin", "operation", "finance", "security"] },
  { path: `${process.env.PUBLIC_URL}/reservations/create`, Component: <ReservationCreate />, roles: ["superadmin", "finance"] },
  { path: `${process.env.PUBLIC_URL}/reservations/edit/:id`, Component: <ReservationEdit />, roles: ["superadmin", "finance"] },
  { path: `${process.env.PUBLIC_URL}/reservations/view/:id`, Component: <ReservationView />, roles: ["superadmin", "operation", "finance", "security"] },

  // transactions
  { path: `${process.env.PUBLIC_URL}/transactions`, Component: <TransactionMain />, roles: ["superadmin", "finance"] },

  // users
  { path: `${process.env.PUBLIC_URL}/users`, Component: <UserMain />, roles: ["superadmin", "operation", "finance", "security"] },
  { path: `${process.env.PUBLIC_URL}/users/create`, Component: <UserCreate />, roles: ["superadmin", "finance"] },
  { path: `${process.env.PUBLIC_URL}/users/edit/:id`, Component: <UserEdit />, roles: ["superadmin", "finance"] },
  { path: `${process.env.PUBLIC_URL}/profile`, Component: <Profile />, roles: ["superadmin", "operation", "finance", "security"] },

  // reports
  { path: `${process.env.PUBLIC_URL}/reports`, Component: <Report />, roles: ["superadmin", "operation", "finance", "security"] },
  
  // settings
  { path: `${process.env.PUBLIC_URL}/pages`, Component: <Page />, roles: ["superadmin", "operation", "finance", "security"] },
  { path: `${process.env.PUBLIC_URL}/calendar`, Component: <Settings />, roles: ["superadmin", "operation", "finance", "security"] },

  // activity logs
  { path: `${process.env.PUBLIC_URL}/activity-logs`, Component: <ActivityLog />, roles: ["superadmin", "operation", "finance"] },

  // errors
  { path: `${process.env.PUBLIC_URL}/err400`, Component: <Error400 /> },
  { path: `${process.env.PUBLIC_URL}/err401`, Component: <Error401 /> },
  { path: `${process.env.PUBLIC_URL}/err403`, Component: <Error403 /> },
  { path: `${process.env.PUBLIC_URL}/err404`, Component: <Error404 /> },
  { path: `${process.env.PUBLIC_URL}/err500`, Component: <Error500 /> },
  { path: `${process.env.PUBLIC_URL}/err503`, Component: <Error503 /> },
];